import type { SVGProps } from "react";

/**
 * Icons lucide has no match for, drawn the way its are (a 24 square, a 2 stroke, round ends) so they sit
 * beside them. Tyler had found none for the cellar's buttons (2026-10-05), so these are a first try: a
 * conical fermenter on its legs, with a gear to manage the cellar, or ghosted with an eye for the tanks
 * hidden from the schedule.
 */

type IconProps = { size?: number } & SVGProps<SVGSVGElement>;

function Icon({ size = 24, children, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}
    >
      {children}
    </svg>
  );
}

const TANK = "M4.5 2h8a1 1 0 0 1 1 1v7.5l-5 4-5-4V3a1 1 0 0 1 1-1z";

/** Manage cellar: a fermenter and a gear. */
export function CellarIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d={TANK} />
      <path d="M8.5 14.5V17" />
      <path d="M4.2 11 3 20" />
      <path d="M12.8 11l.4 3" />
      <circle cx="18" cy="17.5" r="2.2" />
      <path d="M18 13v1.6M18 20.4V22M22.5 17.5h-1.6M15.1 17.5h-1.6M21.2 14.3l-1.1 1.1M15.9 19.6l-1.1 1.1M21.2 20.7l-1.1-1.1M15.9 15.4l-1.1-1.1" />
    </Icon>
  );
}

/** Hidden tanks: a fermenter ghosted, and an eye. */
export function HiddenTanksIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d={TANK} strokeDasharray="2.2 2.1" />
      <path d="M8.5 14.5V17" strokeDasharray="2 2" />
      <path d="M4.2 11 3 20" strokeDasharray="2.2 2.1" />
      <path d="M13 18c1.4-2 3-3 4.5-3s3.1 1 4.5 3c-1.4 2-3 3-4.5 3S14.4 20 13 18z" />
      <circle cx="17.5" cy="18" r="1" />
    </Icon>
  );
}
